<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  progress: { type: Number, default: 0 },
});

const emit = defineEmits(['deliver']);
const { t } = useI18n();
const value = computed(() =>
  Math.min(100, Math.max(0, Number(props.progress) || 0))
);
const colorClass = computed(() => {
  if (value.value >= 100) return 'accent-lais-primary';
  if (value.value > 0) return 'accent-amber-500';
  return 'accent-lais-text-muted';
});
</script>

<template>
  <footer
    class="relative mb-[70px] border border-lais-border-soft bg-white p-[10px] shadow-lais-soft min-[701px]:sticky min-[701px]:bottom-0 min-[701px]:z-20 min-[701px]:mb-0 min-[701px]:px-[30px] min-[701px]:py-[14px]"
    data-test="sales-registration-footer"
  >
    <div
      class="mx-auto flex w-full max-w-[1160px] items-end justify-between gap-3"
    >
      <div class="mr-[10px] min-w-0 w-full max-w-[923px]">
        <div
          class="flex items-center justify-between gap-3 text-base font-bold text-lais-text-muted min-[701px]:text-xl"
          data-test="sales-registration-footer-indicator"
        >
          <span data-test="sales-registration-footer-value">
            {{ t('SALES.COMMON.PERCENT', { value: value }) }}
          </span>
          <span data-test="sales-registration-footer-title">
            {{ t('SALES.FOOTER.PROGRESS') }}
          </span>
        </div>
        <progress
          class="my-1.5 h-1.5 w-full rounded-full min-[701px]:my-2"
          :class="colorClass"
          :value="value"
          max="100"
          :aria-label="t('SALES.FOOTER.PROGRESS')"
          data-test="sales-registration-footer-progress"
        />
      </div>
      <LaisPrimaryButton
        :disabled="value < 100"
        size="lg"
        class="max-[700px]:hidden"
        data-test="sales-registration-footer-deliver"
        @click="emit('deliver')"
      >
        {{ t('SALES.FOOTER.DELIVER') }}
      </LaisPrimaryButton>
    </div>
  </footer>
</template>
